import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpRequestService} from '../../../shared/services/http-request.service';
import {map} from 'rxjs/operators';

@Injectable()
export class SurveyMonkeyService {
  private surveyMonkeyApiUrl = `${environment.apiUrl}/SurveyMonkey/`;
  private getAllFolderUrl = `${this.surveyMonkeyApiUrl}GetAllFolder`;
  private getFolderDetailsUrl = `${this.surveyMonkeyApiUrl}GetFolderDetails`;
  private importSurveyUrl = `${this.surveyMonkeyApiUrl}ImportSurvey`;
  private ImportExistingSurveyUrl = `${this.surveyMonkeyApiUrl}ImportExistingSurvey`;
  private surveyMonkeyAuthorizationUrl = `${this.surveyMonkeyApiUrl}IsSurveyMonkeyAuthorization`;

  constructor(private http: HttpRequestService) {
  }

  getAllFolder(clientId: Number) {
    return this.http.get(this.getAllFolderUrl + '?clientId=' + clientId);
  }

  getFolderDetails(folderId: string, clientId: Number) {
    return this.http.get(`${this.getFolderDetailsUrl}?folderId=${folderId}&clientId=${clientId}`)
      .pipe(
        map(res => {
          res.data.forEach(s => {
            s.questionCount = s.question_count;
            s.responseCount = s.response_count;
          });
          return res;
        })
      );
  }

  importSurvey(s) {
    return this.http.post(this.importSurveyUrl, s);
  }

  ImportExistingSurvey(s) {
    return this.http.post(this.ImportExistingSurveyUrl, s);
  }

  isSurveyMonkeyAuthorization(clientId: Number) {
    return this.http.get(this.surveyMonkeyAuthorizationUrl + '?clientId=' + clientId);
  }  
  
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/survey-monkey/survey-monkey.service.ts